import { Box } from "@adfenix/alexandria";

export const BooleanCell = ({ checked }: { checked: boolean }) => (
  <Box>{checked ? <i className="uil uil-check is-size-4" /> : ""}</Box>
);
